import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <footer className="bg-gray-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="bg-white rounded-xl inline-block px-4 py-3 mb-6">
              <img
                src="https://static.readdy.ai/image/afaf0eabbceea583753f6e045d53514c/4a78b5f12f124598ea76de217c0e359d.svg"
                alt="Blu-Point Logo"
                className="h-10 w-auto"
              />
            </div>
            <h4 className="text-3xl font-bold mb-4 leading-tight">
              Commercial Cleaning<br />Services
            </h4>
            <p className="text-white/80 text-sm leading-relaxed mb-8 max-w-md">
              Delivering exceptional commercial cleaning solutions with certified professionals, 
              eco-friendly products, and 24/7 availability. Your trusted partner for maintaining 
              pristine business environments.
            </p>
            <div className="mb-4">
              <label className="text-sm font-semibold mb-2 block">Stay Updated</label>
              <form onSubmit={handleSubscribe} className="space-y-3">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-transparent border-b border-white/30 pb-2 text-sm focus:outline-none focus:border-white transition-colors placeholder:text-white/50"
                />
                <button
                  type="submit"
                  className="border border-white/50 text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-white hover:text-gray-800 transition-all cursor-pointer whitespace-nowrap"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          <div>
            <h5 className="text-base font-bold mb-4">Services</h5>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Routine Janitorial
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Floor Care
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Window Washing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Carpet Cleaning
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Sanitization
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Post-Construction
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-base font-bold mb-4">Company</h5>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Testimonials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('local-focus')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Local Focus
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-base font-bold mb-4">Contact</h5>
            <ul className="space-y-3">
              <li>
                <a href="tel:+18005551234" className="text-lg font-semibold text-white hover:text-white/80 transition-colors">
                  (650) 273-0074
                </a>
              </li>
              <li>
                <a href="mailto:sales@blu-pointserv.com" className="text-sm text-white/80 hover:text-white transition-colors">
                  sales@blu-pointserv.com
                </a>
              </li>
              <li className="text-sm text-white/80 pt-2">
                Mon - Fri: 7am - 7pm<br />
                Sat - Sun: 9am - 5pm<br />
                Emergency: 24/7
              </li>
              <li className="flex gap-3 pt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-twitter-fill text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/70">
            © 2024 Commercial Janitorial Services. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-white/70 hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-white/70 hover:text-white transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}